import type { ActionType } from '@/shared/components/ActionsDropdown'

import { CopyIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

import { usePricingCampaignContext } from '../ui/PricingCampaignProvider'

export function useSettingsActions({
	settingPaths,
}: {
	/**
	 * Settings path in pricing campaign object (e.g. 'settings.price_limits')
	 * @example ['settings.price_limits', 'settings.pricing_tactics']
	 * */
	settingPaths: string[]
}): ActionType[] {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const context = usePricingCampaignContext()
	const handleCopy = () => {
		// Dynamic event name - using ampli.track() for flexibility
		// TODO: Dynamic event name needs manual handling - consider adding to tracking plan
		ampli.track({
			event_type: `settings: pricing campaigns: setting: dropdown: copy PC setting: ${settingPaths} to PC`,
		})
		showModal('COPY_PRICING_CAMPAIGN_SETTINGS', {
			selected: context.pricingCampaignId!,
			initialStep: 'campaigns',
			selectedSetting: settingPaths,
		})
	}

	return [
		{
			key: 'copy_settings_to_pc',
			label: t('pc.settings.action.copy', { defaultValue: 'Copy to ' }),
			icon: <CopyIcon />,
			onClick: ({ close }: { close: () => void }) => {
				handleCopy()
				close()
			},
			testId: 'pc-settings-action-copy-setting-to-pc',
		},
	]
}
